<template>
  <div class="param-page" v-loading="loading">
    <el-form label-width="120px" class="param-form" style="max-width:640px">
      <el-form-item label="项目初始成员">
        <el-select
          v-model="memberUsernames"
          multiple
          filterable
          clearable
          placeholder="请选择用户（可多选）"
          style="width:100%"
        >
          <el-option
            v-for="u in users"
            :key="u.id"
            :label="userLabel(u)"
            :value="u.username"
          />
        </el-select>
        <div class="hint">新建项目时自动勾选这些成员</div>
      </el-form-item>

      <el-form-item label="一键投诉电话">
        <el-input
          v-model="complaintPhone"
          maxlength="32"
          clearable
          placeholder="请输入投诉电话"
          style="width:100%"
        />
        <div class="hint">小程序「我的项目」一键投诉拨打的电话</div>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" icon="el-icon-check" :loading="saving" @click="save">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { listParams, saveParam, listUsers } from '../../api/sys'

const CODE_MEMBER = 'Default-Project-Member'
const CODE_COMPLAINT = 'COMPLAINTS'

export default {
  name: 'SysParam',
  data() {
    return {
      loading: false,
      saving: false,
      users: [],
      memberUsernames: [],
      complaintPhone: '',
      memberMeta: null,
      complaintMeta: null
    }
  },
  created() {
    this.load()
  },
  methods: {
    userLabel(u) {
      const name = u.nickname || u.username
      return u.nickname && u.nickname !== u.username
        ? `${u.nickname}（${u.username}）`
        : name
    },
    async load() {
      this.loading = true
      try {
        const [paramRes, userRes] = await Promise.all([
          listParams(),
          listUsers({})
        ])
        const params = paramRes.data || []
        this.users = ((userRes.data || [])).filter(u =>
          u.enabled !== 0 &&
          !(Array.isArray(u.roleCodes) ? u.roleCodes : [u.roleCode]).some(c =>
            c === 'SUPPLIER' || c === 'WORKER'
          )
        )
        this.memberMeta = params.find(p => p.paramCode === CODE_MEMBER) || {
          paramCode: CODE_MEMBER,
          paramName: '项目初始成员',
          remark: '新建项目时自动勾选这些成员'
        }
        this.complaintMeta = params.find(p => p.paramCode === CODE_COMPLAINT) || {
          paramCode: CODE_COMPLAINT,
          paramName: '一键投诉电话',
          remark: '小程序「我的项目」一键投诉拨打的电话'
        }
        const raw = (this.memberMeta.paramValue || '').trim()
        this.memberUsernames = raw
          ? raw.split(/[,，]/).map(s => s.trim()).filter(Boolean)
          : []
        this.complaintPhone = this.complaintMeta.paramValue || ''
      } finally {
        this.loading = false
      }
    },
    async save() {
      const phone = (this.complaintPhone || '').trim()
      if (phone && !/^[\d\-+\s()]{5,32}$/.test(phone)) {
        return this.$message.warning('请输入正确的投诉电话')
      }
      this.saving = true
      try {
        await saveParam({
          id: this.memberMeta.id || null,
          paramCode: CODE_MEMBER,
          paramName: this.memberMeta.paramName || '项目初始成员',
          paramValue: (this.memberUsernames || []).join(','),
          remark: this.memberMeta.remark || '新建项目时自动勾选这些成员'
        })
        await saveParam({
          id: this.complaintMeta.id || null,
          paramCode: CODE_COMPLAINT,
          paramName: this.complaintMeta.paramName || '一键投诉电话',
          paramValue: phone,
          remark: this.complaintMeta.remark || '小程序「我的项目」一键投诉拨打的电话'
        })
        this.$message.success('已保存')
        await this.load()
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style scoped>
.param-page {
  max-width: 720px;
}
.hint {
  margin-top: 6px;
  font-size: 12px;
  color: #94a3b8;
  line-height: 1.4;
}
</style>
